import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const S = {
  Typography: styled(Typography)`
    font-weight: bold;
  `,
};

/**
 * Heading을 사용하여 각 페이지에 대한 제목을 나타낼 수 있습니다.
 *
 * @version 1.0.0
 * @author [chayeoi](https://github.com/chayeoi)
*/

const Heading = props => (
  <S.Typography
    component="h2"
    variant="h2"
    {...props}
  />
);

export default Heading;
